import { axios } from '@/plugins/axios';


export default class Gs1Service
{
    public static async calculateCheckDigit(model: CalculateCheckDigitModel): Promise<CalculateCheckDigitResult>
    {
        return (await axios.post<CalculateCheckDigitResult>('admin/gs1/calcualate-check-digit', model)).data;
    }

    public static async validateCode(model: ValidateCodeModel): Promise<ValidateCodeResult>
    {
        return (await axios.post<ValidateCodeResult>('admin/gs1/validate-code', model)).data;
    }
}

export interface CalculateCheckDigitResult {
    result: number;
}

export interface CalculateCheckDigitModel {
    input: string;
}

export interface ValidateCodeModel {
    code: string;
}

export interface ValidateCodeResult {
    anyError: boolean;
    notValidLengthForGtin: boolean;
    emptyValue: boolean;
    withLetterOrSpecialCharacter: boolean;
    checkDigitIsDifferent: boolean;
    currentCheckDigit: number;
    calculatedCheckDigit: number;
}
